getUserLocalData